/**
 * Upload e download di file verso le route acquisti.
 *
 * Il client condiviso (`@shared/services/api`) parla solo JSON: imposta `Content-Type:
 * application/json` e serializza il body. Per i documenti serve un multipart in andata e un blob
 * al ritorno, quindi qui si fa la stessa cosa a mano — stesso token, stesso refresh su 401 — invece
 * di toccare un client che usa anche manutenzioni.
 */

import { getToken, refreshToken } from "@shared/services/tokenStore";
import { ApiError } from "@shared/services/api";

const API_BASE_URL = import.meta.env.VITE_API_URL ?? "";

async function conToken(eseguiRichiesta) {
  let risposta = await eseguiRichiesta(getToken());
  if (risposta.status === 401) {
    const nuovo = await refreshToken().catch(() => null);
    if (nuovo) risposta = await eseguiRichiesta(nuovo);
  }
  if (!risposta.ok) {
    const isJson = risposta.headers
      .get("content-type")
      ?.includes("application/json");
    const dati = isJson
      ? await risposta.json()
      : { message: risposta.statusText };
    throw new ApiError(
      dati.message || `HTTP ${risposta.status}`,
      risposta.status,
      dati,
    );
  }
  return risposta;
}

/** POST multipart con il file nel campo `file`, piu' eventuali campi testuali. */
export async function caricaFile(endpoint, file, campi = {}) {
  const risposta = await conToken((token) => {
    const form = new FormData();
    form.append("file", file);
    for (const [k, v] of Object.entries(campi)) {
      if (v !== undefined && v !== null) form.append(k, v);
    }
    return fetch(`${API_BASE_URL}${endpoint}`, {
      method: "POST",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: form,
    });
  });
  return risposta.json();
}

/** Scarica e apre il file in una scheda nuova (PDF, immagini) o lo salva (il resto). */
export async function apriFile(endpoint, nomeFallback = "documento") {
  const risposta = await conToken((token) =>
    fetch(`${API_BASE_URL}${endpoint}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }),
  );
  const blob = await risposta.blob();
  const url = URL.createObjectURL(blob);
  if (blob.type === "application/pdf" || blob.type.startsWith("image/")) {
    window.open(url, "_blank", "noopener");
  } else {
    const a = document.createElement("a");
    a.href = url;
    const cd = risposta.headers.get("content-disposition") || "";
    const m = cd.match(/filename\*=UTF-8''([^;]+)/);
    a.download = m ? decodeURIComponent(m[1]) : nomeFallback;
    a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
